(function(){
  var hdr=document.querySelector('.hdr');
  if(hdr){
    var onScroll=function(){hdr.classList.toggle('stuck',window.scrollY>40)};
    onScroll();addEventListener('scroll',onScroll,{passive:true});
  }
  var burger=document.querySelector('.burger');
  if(burger){
    burger.addEventListener('click',function(){document.body.classList.toggle('menu-open')});
    document.querySelectorAll('.sheet nav > a').forEach(function(a){
      a.addEventListener('click',function(){document.body.classList.remove('menu-open')});
    });
    document.querySelectorAll('.sheet-sub a').forEach(function(a){
      a.addEventListener('click',function(){document.body.classList.remove('menu-open')});
    });
  }
  document.querySelectorAll('.sheet-toggle').forEach(function(btn){
    btn.addEventListener('click',function(){
      var item=btn.closest('.sheet-item');
      if(item){item.classList.toggle('open')}
    });
  });
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}});
    },{rootMargin:'0px 0px -12% 0px',threshold:.08});
    document.querySelectorAll('.rv').forEach(function(el){io.observe(el)});
  } else {
    document.querySelectorAll('.rv').forEach(function(el){el.classList.add('in')});
  }
  // product gallery
  var main=document.querySelector('[data-pd-main] img');
  document.querySelectorAll('[data-pd-thumb]').forEach(function(t){
    t.addEventListener('click',function(){
      var src=t.getAttribute('data-full');
      if(main&&src){main.src=src;main.srcset='';}
      document.querySelectorAll('[data-pd-thumb]').forEach(function(x){x.setAttribute('aria-current','false')});
      t.setAttribute('aria-current','true');
    });
  });
})();
